export function getdata() {
	var obj = {
		
			headDatasvii:[
					{
						title: "实际缴纳企业所得税计算",
						prop: "groud",
					},
					{
						title: "",
						prop: "text",
						custom: true,
					},
					{
						title: "",
						prop: "title",
						custom: true,
					},
					{
						title: "",
						prop: "setout",
						custom: true,
					},
					{
						title: "",
						prop: "bfb",
						custom: true,
					},
					{
						title: "",
						prop: "ctox",
						custom: true,
						width:"200px"
					},
					{
						title: "",
						width:"200px",
						prop: "sdsA_1_x_3",
						custom: true,
					},
			],
			tableDatasvii:[
				{
					groud:'FZ1',
					text:'中央级收入实际应纳税额[本期：16行*60%或(18行+20行)*60%+19或22行*60%]',
					title:'',
					setout:'',
					bfb:'',
					ctox:'',
					disabledsdsA_1_x_3:false,
					sdsA_1_x_3: {
						cellCode:"sdsA_1_22_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},
				{
					groud:'FZ2',
					text:'地方级收入应纳税额[本期：16行*40%或(18行+20行)*40%或22行*40%]',
					title:'',
					setout:'',
					bfb:'',
					ctox:'',
					disabledsdsA_1_x_3:false,
					sdsA_1_x_3: {
						cellCode:"sdsA_1_22_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},
				{
					groud:'23',
					text:'减：民族自治地区企业所得税地方分享部分',
					title:'0无0免征0减征',
					setout:'减征幅度',
					bfb:'0',
					ctox:'本期实际减免金额（FZ2*减征幅度）',
					disabledsdsA_1_x_3:false,
					sdsA_1_x_3: {
						cellCode:"sdsA_1_22_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},
				{
					groud:'23.1',
					text:'减：民族自治地区企业所得税地方分享部分',
					title:'本期实际减免金额（FZ2*减征幅度）',
					setout:'减征幅度',
					bfb:'0%',
					ctox:'本机构本年累计的（23行的本年累计）',
					disabledsdsA_1_x_3:false,
					sdsA_1_x_3: {
						cellCode:"sdsA_1_22_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},
				{
					groud:'23.2',
					text:'减：民族自治地区企业所得税地方分享部分',
					title:'',
					setout:'减征幅度',
					bfb:'0%',
					ctox:'本年累计应减免金额（总机构及分支机构的本年累计，总机构填报）',
					disabledsdsA_1_x_3:false,
					sdsA_1_x_3: {
						cellCode:"sdsA_1_22_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},
				{
					groud:'FZ3',
					text:'地方级收入实际应纳税额（本期：FZ2-23）',
					title:'',
					setout:'',
					bfb:'',
					ctox:'',
					disabledsdsA_1_x_3:false,
					sdsA_1_x_3: {
						cellCode:"sdsA_1_22_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},
				{
					groud:'24',
					text:'实际应补（退）所得税额（本期：FZ1+FZ3）',
					title:'',
					setout:'',
					bfb:'',
					ctox:'',
					disabledsdsA_1_x_3:false,
					sdsA_1_x_3: {
						cellCode:"sdsA_1_22_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
				}
			],
			headDatasvi:[
					{
					title: "汇总纳税企业总分机构税款计算",
					prop: "groud",
					width: "100px",
				},{
					title: "",
					prop: "text",
					width: "100px",
					custom: true,
				},{
					title: "",
					prop: "title",
					 width:'400px',
					align:"left",
					custom: true,
				},{
					title: "",
					prop: "sdsA_1_x_3",
					width: "200px",
					custom: true,
				},
			],
			
			tableDatasvi:[
				{
					groud:'17',
					text:'总机构',
					title:'总机构本期分摊应补（退）所得税额（18+19+20）',
					disabledsdsA_1_x_3:true,
					sdsA_1_x_3: {
						cellCode:"sdsA_1_16_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},
				{
					groud:'18',
					text:'总机构',
					title:'其中：总机构分摊应补（退）所得税额（16×总机构分摊比例 ' ,
					disabledsdsA_1_x_3:true,
					sdsA_1_x_3: {
						cellCode:"sdsA_1_17_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},
				{
					groud:'19',
					text:'总机构',
					title:'财政集中分配应补（退）所得税额（16×财政集中分配比例',
					disabledsdsA_1_x_3:true,
					sdsA_1_x_3: {
						cellCode:"sdsA_1_18_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},
				{
					groud:'20',
					text:'总机构',
					title:'总机构具有主体生产经营职能的部门分摊所得税额（16×全部分支机构分摊比例sdsA_1_20_1×总机构具有主体生产经营职能部门分摊比例 sdsA_1_20_2 ）',
					disabledsdsA_1_x_3:true,
					sdsA_1_x_3: {
						cellCode:"sdsA_1_19_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},
				{
					groud:'21',
					text:'分支机构填报',
					title:'分支机构本期分摊比例',
					disabledsdsA_1_x_1:false,
					sdsA_1_x_3: {
						cellCode:"sdsA_1_20_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},
				{
					groud:'22',
					text:'分支机构填报',
					title:'分支机构本期分摊应补（退）所得税额',
					disabledsdsA_1_x_1:false,
					sdsA_1_x_3: {
						cellCode:"sdsA_1_21_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},
			],
			headDatasv:[{
				title: "预缴税款计算",
				children:[
				
				{
					title: "行次",
					prop: "hanh",
					width:'100px',
				},{
					title: "项目",
					prop: "title",
					custom: true,
				
				width:'450px',
				},{
					title: "本年累计金额",
					prop: "sdsA_1_x_2",
					custom: true,
				
				width:'200px',
				},
				]
			}],
			tableDatasv:[
				{
					groud:'1',
					title:'营业收入',
					disabledsdsA_1_x_1:false,
					sdsA_1_x_1: {
						cellCode:"sdsA_1_1_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},
				{
					groud:'2',
					title:'营业成本',
					disabledsdsA_1_x_1:false,
					sdsA_1_x_1: {
						cellCode:"sdsA_1_2_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},
				{
					groud:'3',
					title:'利润总额',
					disabledsdsA_1_x_1:false,
					sdsA_1_x_1: {
						cellCode:"sdsA_1_3_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},
				{
					groud:'4',
					title:'加：特定业务计算的应纳税所得额',
					disabledsdsA_1_x_1:false,
					sdsA_1_x_1: {
						cellCode:"sdsA_1_4_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},
				{
					groud:'5',
					title:'减：不征税收入',
					disabledsdsA_1_x_1:false,
					sdsA_1_x_1: {
						cellCode:"sdsA_1_5_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},
				{
					groud:'6',
					title:'减：资产加速折旧、摊销（扣除）调减额（填写A201020）',
					disabledsdsA_1_x_1:false,
					sdsA_1_x_1: {
						cellCode:"sdsA_1_6_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},
				{
					groud:'7',
					title:'减：免税收入、减计收入、加计扣除（7.1+7.2+7.3+...）',
					disabledsdsA_1_x_1:false,
					sdsA_1_x_1: {
						cellCode:"sdsA_1_7_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},
				{
					groud:'8',
					title:'减：所得减免（8.1+8.2+...）',
					disabledsdsA_1_x_1:false,
					sdsA_1_x_1: {
						cellCode:"sdsA_1_8_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},
				{
					groud:'9',
					title:'减：弥补以前年度亏损',
					disabledsdsA_1_x_1:false,
					sdsA_1_x_1: {
						cellCode:"sdsA_1_9_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},
				{
					groud:'10',
					title:'实际利润额（3+4-5-6-7-8-9）\\按照上一纳税年度应纳税所得额平均额确定的应纳税所得额',
					disabledsdsA_1_x_1:false,
					sdsA_1_x_1: {
						cellCode:"sdsA_1_10_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},
				{
					groud:'11',
					title:'税率(25%)',
					disabledsdsA_1_x_2:true,
					sdsA_1_x_1: {
						cellCode:"sdsA_1_11_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},
				{
					groud:'12',
					title:'应纳所得税额（10×11）',
					disabledsdsA_1_x_1:false,
					sdsA_1_x_1: {
						cellCode:"sdsA_1_12_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},
				{
					groud:'13',
					title:'减：减免所得税额（13.1+13.2+...）',
					disabledsdsA_1_x_1:false,
					sdsA_1_x_1: {
						cellCode:"sdsA_1_13_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},
				{
					groud:'13.1',
					title:'高新技术企业减按15%的税率征收企业所得税',
					disabledsdsA_1_x_1:false,
					sdsA_1_x_1: {
						cellCode:"sdsA_1_14_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},{
					groud:'13.2',
					title:'符合条件的小型微利企业减免企业所得税',
					disabledsdsA_1_x_1:false,
					sdsA_1_x_1: {
						cellCode:"sdsA_1_14_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},
				{
					groud:'14',
					title:'减：本年实际已缴纳所得税额',
					disabledsdsA_1_x_1:false,
					sdsA_1_x_1: {
						cellCode:"sdsA_1_15_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},
				{
					groud:'15',
					title:'减：特定业务预缴（征）所得税额',
					disabledsdsA_1_x_1:false,
					sdsA_1_x_1: {
						cellCode:"sdsA_1_16_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},
				{
					groud:'16',
					title:'本期应补（退）所得税额(12-13-14-15)\\税务机关确定的本期应纳所得税额',
					disabledsdsA_1_x_1:false,
					sdsA_1_x_1: {
						cellCode:"sdsA_1_15_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},
				
				
			],	
			headDatas:[
				{
				title: "代码",
				width:'100px',
				prop: "title",
				
				custom: true,
			},{
				title: "附报事项名称",
				prop: "sdsA_1_x_1",
				
				custom: true,
				width:"450px"
			},{
				title: "金额或选项",
				prop: "sdsA_1_x_2",
				width:'200px',
				custom: true,
			},
			],
			tableDatas:[
				{
					title: "扶贫捐赠支持全额扣除（本年累计，元）",
					code:"K01002"
				},{
					title: "软件集成电路企业按新政策或原政策执行优惠（单选：原政策/新政策）",
					code:"Y01001"
				},{
					title: "高新技术企业资格证书发证时间",
					code:"Y01002"
				},
			],
			headData: [
				{
					title: "优惠及附报事项有关信息",
					children:[{
						title: "项目",
						prop: "title",
						custom: true,
					},{
						title: "一季度",
						children:[{
							title: "季初",
							prop: "sdsA_1_x_1",
							
							custom: true,
						},
						{
							title: "季末",
							
							prop: "sdsA_1_x_2",
							custom: true,
						}]
						
					},{
						title: "二季度",
						children:[{
							title: "季初",
							prop: "sdsA_1_x_3",
							
							custom: true,
						},
						{
							title: "季末",
							prop: "sdsA_1_x_4",
							
							custom: true,
						}]
						
					},{
						title: "三季度",
						children:[{
							title: "季初",
							prop: "sdsA_1_x_5",
							
							custom: true,
						},
						{
							title: "季末",
							prop: "sdsA_1_x_6",
							
							custom: true,
						}]
						
					},{
						title: "四季度",
						children:[{
							title: "季初",
							prop: "sdsA_1_x_7",
							
							custom: true,
						},
						{
							title: "季末",
							prop: "sdsA_1_x_8",
							
							custom: true,
						}]
					},{
						title: "季度平均值",
						prop: "sdsA_1_x_9",
							
							custom: true,
					}]
					
				},
				
			],
			tableData: [{
					title: "从业人数",
					disabledsdsA_1_x_1:false,
					disabledsdsA_1_x_2:false,
					disabledsdsA_1_x_3:false,
					disabledsdsA_1_x_4:false,
					disabledsdsA_1_x_5:false,
					disabledsdsA_1_x_6:false,
					disabledsdsA_1_x_7:false,
					disabledsdsA_1_x_8:false,
					disabledsdsA_1_x_9:true,
					sdsA_1_x_1: {
						cellCode:"sdsA_1_1_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
					sdsA_1_x_2: {
						cellCode:"sdsA_1_1_2",
						cellType:"1",
						cellVal:"240040043.08"
					},
					sdsA_1_x_3: {
						cellCode:"sdsA_1_1_3",
						cellType:"1",
						cellVal:"240040043.8"
					},
					sdsA_1_x_4: {
						cellCode:"sdsA_1_1_4",
						cellType:"1",
						cellVal:"240040043.08"
					},
					sdsA_1_x_5: {
						cellCode:"sdsA_1_1_5",
						cellType:"1",
						cellVal:"240040043.08"
					},
					sdsA_1_x_6: {
						cellCode:"sdsA_1_1_6",
						cellType:"1",
						cellVal:"240040043.08"
					},
					sdsA_1_x_7: {
						cellCode:"sdsA_1_1_7",
						cellType:"1",
						cellVal:"240040043.08"
					},
					sdsA_1_x_8: {
						cellCode:"sdsA_1_1_8",
						cellType:"1",
						cellVal:"240040043.08"
					},
					sdsA_1_x_9: {
						cellCode:"sdsA_1_1_9",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},
				{
					title: "资产总额（万元）",
					disabledsdsA_1_x_1:false,
					disabledsdsA_1_x_2:false,
					disabledsdsA_1_x_3:false,
					disabledsdsA_1_x_4:false,
					disabledsdsA_1_x_5:false,
					disabledsdsA_1_x_6:false,
					disabledsdsA_1_x_7:false,
					disabledsdsA_1_x_8:false,
					disabledsdsA_1_x_9:true,
					sdsA_1_x_1: {
						cellCode:"sdsA_1_2_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
					sdsA_1_x_2: {
						cellCode:"sdsA_1_2_2",
						cellType:"1",
						cellVal:"240040043.08"
					},
					sdsA_1_x_3: {
						cellCode:"sdsA_1_2_3",
						cellType:"1",
						cellVal:"240040043.8"
					},
					sdsA_1_x_4: {
						cellCode:"sdsA_1_2_4",
						cellType:"1",
						cellVal:"240040043.08"
					},
					sdsA_1_x_5: {
						cellCode:"sdsA_1_2_5",
						cellType:"1",
						cellVal:"240040043.08"
					},
					sdsA_1_x_6: {
						cellCode:"sdsA_1_2_6",
						cellType:"1",
						cellVal:"240040043.08"
					},
					sdsA_1_x_7: {
						cellCode:"sdsA_1_2_7",
						cellType:"1",
						cellVal:"240040043.08"
					},
					sdsA_1_x_8: {
						cellCode:"sdsA_1_2_8",
						cellType:"1",
						cellVal:"240040043.08"
					},
					sdsA_1_x_9: {
						cellCode:"sdsA_1_2_9",
						cellType:"1",
						cellVal:"240040043.08"
					},
				}
			]
		
	}
	return obj
}
